import { AbstractPmsApiService } from "./abstract.service";
import { ZatcaApiLog } from "../models";

/**
 * @class ZatcaApiLogPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<ZatcaApiLog>}
 */
export class ZatcaApiLogPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/zatca-api-log(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {ZatcaApiLog}
     * @protected
     */
    newModel(attributes, ...params) {

        return new ZatcaApiLog(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<ZatcaApiLog>>}
     */
    get(params = {}, property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     *
     * @param {Property=} property
     * @param {ZatcaApiLog=} log
     * @returns {Promise.<Boolean>}
     */
    resend(property, log) {

        const url = this.url({
            propertyId: property.id,
            id: log.id,
        });

        return this.http
            .get(url + '/resend', {
                headers: this.authHeaders,
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/zatca-api-log.service.js